var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-number",style:([_vm.bgStyle])},[_c('span',{staticClass:"text",class:{'text-desktop': !_vm.isInStandaloneMode},style:([{'color': _vm.colorText}])},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"number",style:([{'color': _vm.colorNumber}])},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }